<template>
  <div class="fldy-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加质检记录</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                >
                  <el-table-column
                    label="月份"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.month }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="周次"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.week }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.ordernum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验日期"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.testtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="专卖店"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.delname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总件数"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.comnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良数量"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#f56c6c">{{ scope.row.num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="颜色"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.crafts }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良现象描述"
                    min-width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.desc }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="处理措施"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.measures }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良类别"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.bad }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任部门"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.dept }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="直接责任人"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.resName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="设计师"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.designer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验工序"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.process }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验员"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.userName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.remark }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="添加时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="240"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button size="mini" @click="addRework(scope.row)"><i class="el-icon-plus"></i>添加返工单</el-button>
                      <el-dropdown size="mini" split-button icon="el-icon-edit" @click.stop="editRow(scope.row)">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="color:#F56C6C" @click.native="deleteRow(scope.row)"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
          <el-dialog
            :title="editTitle"
            :visible.sync="dialogVisible"
            width="800px"
            top="10vh"
            :destroy-on-close="true"
            :lock-scroll="true"
            :append-to-body="true"
          >
            <div v-loading="editFormLoading">
              <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="editRules">
                <el-form-item label="检验日期" prop="testtime">
                  <el-date-picker
                    v-model="editForm.testtime"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="选择订单" prop="orderid">
                  <OrderChoose :key="keyNum1" v-model="editForm.orderid" :oldorderid="editForm.oldorderid" :mark="13"></OrderChoose>
                </el-form-item>
                <el-form-item label="不良数量" prop="num">
                  <el-input-number v-model="editForm.num" :min="0" :max="editForm.incomnum" :precision="0"></el-input-number>
                </el-form-item>
                <el-form-item label="不良现象描述" prop="desc">
                  <el-input
                    v-model="editForm.desc"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    maxlength="300"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="处理措施" prop="measures">
                  <el-select v-model="editForm.measures" placeholder="请选择">
                    <el-option
                      v-for="item in measures"
                      :key="item.qmid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="责任部门" prop="dept">
                  <el-select v-model="editForm.dept" placeholder="请选择" @change="selectBads()">
                    <el-option
                      v-for="item in depts"
                      :key="item.qdid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="不良类别" prop="bad">
                  <el-select v-model="editForm.bad" placeholder="请选择">
                    <el-option
                      v-for="item in bads"
                      :key="item.qbid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="直接责任人" prop="resid">
                  <UserSelect :key="keyNum2" v-model="editForm.resid" :set="editForm.oldresid" :userid="user.dUserid"></UserSelect>
                </el-form-item>
                <el-form-item label="检验工序" prop="process">
                  <el-select v-model="editForm.process" placeholder="请选择">
                    <el-option
                      v-for="item in processData"
                      :key="item.qpid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="检验员" prop="userid">
                  <UserSelect :key="keyNum3" v-model="editForm.userid" :set="editForm.oldid" :userid="user.dUserid"></UserSelect>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input
                    v-model="editForm.remark"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    maxlength="300"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
                <el-form-item style="text-align: right">
                  <el-button :loading="eidtLoading" type="primary" @click="SubForm('editForm')">立即提交</el-button>
                  <el-button @click="dialogVisible=false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog
            :title="reworkTitle"
            :visible.sync="reworkdialogVisible"
            width="800px"
            top="10vh"
            :destroy-on-close="true"
            :lock-scroll="true"
            :append-to-body="true"
          >
            <div v-loading="reworkEditFormLoading">
              <el-form ref="reworkEditForm" size="small" :model="reworkEditForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="reworkRules">
                <el-form-item label="选择时间" prop="time">
                  <el-date-picker
                    v-model="reworkEditForm.time"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="责任工序" prop="process">
                  <el-select v-model="reworkEditForm.process" placeholder="请选择" @change="isDesign()">
                    <el-option
                      v-for="item in reworkProcessData"
                      :key="item.rpid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="返工成本" prop="cost">
                  <el-input-number v-model="reworkEditForm.cost" :min="0" :precision="2"></el-input-number>
                </el-form-item>
                <el-form-item label="人工成本" prop="laborCost">
                  <el-input-number v-model="reworkEditForm.laborCost" :min="0" :precision="2"></el-input-number>
                </el-form-item>
                <el-form-item label="材料成本" prop="stuffCost">
                  <el-input-number v-model="reworkEditForm.stuffCost" :min="0" :precision="2"></el-input-number>
                </el-form-item>
                <el-form-item label="乐捐" prop="punish">
                  <el-input-number v-model="reworkEditForm.punish" :min="0" :precision="2"></el-input-number>
                </el-form-item>
                <!--                <el-form-item label="计划完成" prop="planned">-->
                <!--                  <el-date-picker-->
                <!--                    v-model="reworkEditForm.planned"-->
                <!--                    format="yyyy年MM月dd日"-->
                <!--                    value-format="yyyy-MM-dd"-->
                <!--                    type="date">-->
                <!--                  </el-date-picker>-->
                <!--                </el-form-item>-->
                <el-form-item label="直接责任人" prop="dutyid">
                  <UserSelect :key="keyNum4" v-model="reworkEditForm.dutyid" :set="reworkEditForm.olddutyid" :userid="user.dUserid"></UserSelect>
                </el-form-item>
                <el-form-item label="返修负责人" prop="principalid">
                  <UserSelect :key="keyNum3" v-model="reworkEditForm.principalid" :set="reworkEditForm.oldid" :userid="user.dUserid"></UserSelect>
                </el-form-item>
                <el-form-item style="text-align: right">
                  <el-button :loading="reworkEditLoading" type="primary" @click="SubReworkForm('reworkEditForm')">立即提交</el-button>
                  <el-button @click="reworkdialogVisible=false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OrderChoose from '@/components/OrderChoose/index'
import { getUser } from '@/utils/auth'
import {
  getQualityList,
  getQualityDeptAll,
  selectQualityBadList,
  getQualityProcessAll,
  updateAndaddQuality, exportQualityList, getReworkProcessAll, addReworkOrder, deleteQuality, getQualityMeasuresAll, getOfferAmount
} from '@/api/erp'
import UserSelect from '@/components/UserSelect/index'
import { delExamTask } from '@/api/work'

export default {
  name: 'Zjjl',
  components: { UserSelect, OrderChoose },
  data() {
    return {
      keyNum1: null,
      keyNum2: null,
      keyNum3: null,
      keyNum4: null,
      eidtLoading: false,
      dialogVisible: false,
      editTitle: '添加质检记录',
      exportLoading: false,
      editFormLoading: false,
      searchForm: {
        search: '',
        opertime: []
      },
      loading: false,
      tableData: [],
      depts: [],
      bads: [],
      measures: [],
      reworkProcessData: [],
      processData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      reworkTitle: '添加返工单',
      reworkdialogVisible: false,
      reworkEditFormLoading: false,
      reworkEditLoading: false,
      reworkEditForm: {
        orderid: '',
        roid: null,
        qid: null,
        time: null,
        process: null,
        cost: null,
        // planned: null,
        principalid: null,
        oldid: null,
        dutyid: null,
        olddutyid: null,
        punish: null,
        laborCost: null,
        stuffCost: null
      },
      reworkRules: {
        time: [{ required: true, message: '请选择日期', trigger: 'change' }]
      },
      editForm: {
        qid: null,
        month: null,
        week: null,
        testtime: null,
        orderid: null,
        oldorderid: null,
        num: null,
        desc: null,
        measures: null,
        dept: null,
        bad: null,
        resid: null,
        oldresid: null,
        process: null,
        remark: null,
        userid: null,
        oldid: null
      },
      editRules: {
        testtime: [{ required: true, message: '请选择日期', trigger: 'change' }],
        orderid: [{ required: true, message: '请选择订单', trigger: 'change' }],
        userid: [{ required: true, message: '请选择检验员', trigger: 'change' }]
        // num: [{ required: true, message: '不能为空', trigger: 'change' }],
        // desc: [{ required: true, message: '请在这里填写不良现象描述', trigger: 'blur' }],
        // measures: [{ required: true, message: '请在这里填写处理措施', trigger: 'blur' }],
        // dept: [{ required: true, message: '不能为空', trigger: 'change' }],
        // bad: [{ required: true, message: '不能为空', trigger: 'change' }],
        // resid: [{ required: true, message: '不能为空', trigger: 'change' }],
        // process: [{ required: true, message: '请选择体验工序', trigger: 'change' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getQualityDeptAll()
    this.getQualityProcessAll()
    this.getReworkProcessAll()
    this.getQualityMeasuresAll()
  },
  methods: {
    isDesign() {
      if ((this.reworkEditForm.process).indexOf('设计') >= 0) {
        const data = {
          orderid: this.reworkEditForm.orderid
        }
        getOfferAmount(data).then(response => {
          this.reworkEditForm.cost = response.data.amount
        })
      } else {
        this.reworkEditForm.cost = 0.00
      }
    },
    getQualityMeasuresAll() {
      getQualityMeasuresAll().then(response => {
        this.measures = response.data
      })
    },
    deleteRow(row) {
      this.$confirm('删除此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          qid: row.qid,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid
        }
        deleteQuality(data).then(response => {
          this.getData()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        }).catch(() => {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        })
      })
    },
    addRework(row) {
      this.keyNum4 = new Date().getTime() + 'd'
      this.keyNum2 = new Date().getTime()
      this.reworkEditForm.orderid = row.orderid
      this.reworkEditForm.qid = row.qid
      this.reworkdialogVisible = true
      this.reworkEditForm.time = null
      this.reworkEditForm.process = null
      this.reworkEditForm.cost = 0.00
      // this.reworkEditForm.planned = null
      this.reworkEditForm.principalid = null
      this.reworkEditForm.dutyid = null
      this.reworkEditForm.olddutyid = null
      this.reworkEditForm.punish = 0.00
      this.reworkEditForm.laborCost = 0.00
      this.reworkEditForm.stuffCost = 0.00
    },
    SubReworkForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if ((this.reworkEditForm.laborCost + this.reworkEditForm.stuffCost) === this.reworkEditForm.cost) {
            this.reworkEditLoading = true
            const data = {
              qid: this.reworkEditForm.qid,
              time: this.reworkEditForm.time,
              process: this.reworkEditForm.process,
              cost: this.reworkEditForm.cost,
              // planned: this.reworkEditForm.planned,
              principalid: this.reworkEditForm.principalid,
              dutyid: this.reworkEditForm.dutyid,
              punish: this.reworkEditForm.punish,
              laborCost: this.reworkEditForm.laborCost,
              stuffCost: this.reworkEditForm.stuffCost
            }
            addReworkOrder(data).then(response => {
              this.reworkEditLoading = false
              this.reworkdialogVisible = false
              this.$message.success('提交成功')
            }).catch(() => {
              this.reworkEditLoading = false
              this.$message.error('提交失败')
            })
          } else {
            this.$message.error('返工成本=人工成本+材料成本，请您仔细核对后提交')
          }
        }
      })
    },
    getReworkProcessAll() {
      getReworkProcessAll().then(response => {
        this.reworkProcessData = response.data
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
          startTime = this.searchForm.opertime[0]
          endTime = this.searchForm.opertime[1]
        }
        const data = {
          content: this.searchForm.search,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid,
          startTime: startTime,
          endTime: endTime
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportQualityList(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    editRow(row) {
      // this.editFormLoading = true
      this.dialogVisible = true
      this.keyNum1 = new Date().getTime() + 'a'
      this.keyNum2 = new Date().getTime() + 'b'
      this.keyNum3 = new Date().getTime() + 'c'
      if (row === null) {
        this.editTitle = '添加质检记录'
        this.editForm.qid = null
        this.editForm.month = null
        this.editForm.week = null
        this.editForm.testtime = null
        this.editForm.orderid = null
        this.editForm.oldorderid = null
        this.editForm.num = null
        this.editForm.desc = null
        this.editForm.measures = null
        this.editForm.dept = null
        this.bads = []
        this.editForm.bad = null
        this.editForm.resid = null
        this.editForm.oldresid = null
        this.editForm.process = null
        this.editForm.remark = null
        this.editForm.userid = null
        this.editForm.oldid = null
      } else {
        this.editTitle = '编辑质检记录'
        this.editForm.qid = row.qid
        this.editForm.month = row.month
        this.editForm.week = row.week
        this.editForm.testtime = row.testtime
        this.editForm.oldorderid = row.orderid
        this.editForm.orderid = null
        this.editForm.num = row.num
        this.editForm.desc = row.desc
        this.editForm.measures = row.measures
        this.editForm.dept = row.dept
        this.editForm.bad = row.bad
        this.bads = []
        this.editForm.resid = null
        this.editForm.oldresid = row.resid
        this.editForm.process = row.process
        this.editForm.remark = row.remark
        this.editForm.userid = null
        this.editForm.oldid = row.userid
        this.selectQualityBadList()
      }
    },
    SubForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.eidtLoading = true
          var str = this.editForm.testtime
          str = str.replace(/[^\d]/g, '/')
          var date = new Date(str)
          this.editForm.month = date.getMonth() + 1 + ''
          this.editForm.week = ((date - (new Date(date.getFullYear() + '-01-01'))) / (24 * 60 * 60 * 7 * 1000) | 0) + 1
          if (this.editForm.num === '' || this.editForm.num === null || this.editForm.num === undefined) {
            this.editForm.num = 0
          }
          const data = {
            qid: this.editForm.qid,
            month: this.editForm.month,
            week: this.editForm.week,
            testtime: this.editForm.testtime,
            orderid: this.editForm.orderid,
            num: this.editForm.num,
            desc: this.editForm.desc,
            measures: this.editForm.measures,
            dept: this.editForm.dept,
            bad: this.editForm.bad,
            resid: this.editForm.resid,
            process: this.editForm.process,
            remark: this.editForm.remark,
            userid: this.editForm.userid
          }
          updateAndaddQuality(data).then(response => {
            this.getData()
            this.eidtLoading = false
            this.dialogVisible = false
            this.$message.success('提交成功')
          }).catch(() => {
            this.eidtLoading = false
            this.$message.error('提交失败')
          })
        } else {
          return false
        }
      })
    },
    getQualityProcessAll() {
      getQualityProcessAll().then(response => {
        this.processData = response.data
      })
    },
    getQualityDeptAll() {
      getQualityDeptAll().then(response => {
        this.depts = response.data
      })
    },
    selectBads() {
      this.editForm.bad = null
      this.selectQualityBadList()
    },
    selectQualityBadList() {
      const data = {
        dept: this.editForm.dept
      }
      selectQualityBadList(data).then(response => {
        this.bads = response.data
      })
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        role: this.user.role,
        groupid: this.user.dGroupid,
        startTime: startTime,
        endTime: endTime
      }
      getQualityList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .fldy-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>

